import SourcePoint from '../gdpr/sourcepoint';

class Cxense {
	isActive() {
		return !!(
			window.bi_piano.cxense_site_id &&
			typeof window.bi_piano.cxense_site_id !== 'undefined'
		);
	}

	isAllowed() {
		// No consent is not required for NL
		if (bi_theme.environment === 'nl') {
			return true;
		}

		if (!SourcePoint.vendorHasGrant('cxense')) {
			return false;
		}

		return true;
	}

	maybeInit() {
		// If Cxense is not active or not allowed, bail early
		if (!this.isActive() || !this.isAllowed()) {
			return;
		}

		this.init();
	}

	init() {
		// Set the cxense site ID in Piano. This will trigger the loading of
		// the cx.js and cx.cce.js scripts.
		window.tp.push(['setCxenseSiteId', window.bi_piano.cxense_site_id]);

		// Setup default options for cxense
		// See: https://docs.piano.io/faq-article/gdpr-and-cx-js/
		const cX = (window.cX = window.cX || {});
		cX.callQueue = cX.callQueue || [];
		cX.CCE = cX.CCE || {};
		cX.CCE.callQueue = cX.CCE.callQueue || [];

		// Require consent for cxense
		cX.callQueue.push(['requireConsent']);

		// Add specific consent for cxense
		// For now, only the 'recs' consent is set (recommendations)
		cX.callQueue.push([
			'invoke',
			function () {
				if (!window.cX.hasConsent('recs')) {
					cX.callQueue.push(['setConsent', { recs: true }]);
				}
			},
		]);
	}
}

const instance = new Cxense();
export default instance;
